import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconProjects: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="projects, stack, templates, timeline"><path d="M6.75 3.75H17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 7.25H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21.25 10.75H2.75L4.75 20.25H19.25L21.25 10.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconProjects;
